export default __webpack_public_path__ + "static/media/marker_active.07e197c3.svg";